
import { HostListener, Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Route, Router } from "@angular/router";
import { BehaviorSubject, distinctUntilChanged, noop, tap } from "rxjs";
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { BrowserService } from "projects/shared/services/browser.service";
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  arabic = new BehaviorSubject<boolean>(false);
  selectedCountry = new BehaviorSubject<string>(null!);
  onLoadComplete = new BehaviorSubject<boolean>(true);

  constructor(
    private _router: Router,
    private _location: Location,
    private _browserService: BrowserService
  ) {
    _router.events.pipe(
      distinctUntilChanged(),
      tap(res => {
        if (res instanceof NavigationEnd) {
          this.changeLangToArabic(res.url)
        }
      })
    ).subscribe();
  }
  
  changeLangToArabic(url: string) {
    const localStorageBr = this._browserService.getLocalStorage();
    const LocationeBr = this._browserService.getLocation();
    if (localStorageBr && LocationeBr) {
      if (JSON.parse(localStorage.getItem('UserRegion')!)?.lang == 'ar') {
        this._location.go(this.editRoute(url, true))
      }
      else {
        this._location.go(this.editRoute(url, false))
      }
    }
  }

  private editRoute(route: string, ar: boolean) {
    let u: any = route.split('/');
    u[1] = ar ? 'ar' : 'en'
    return u.join('/').split(',').toString()
  }
}


